<template>
  <div class="pop" :class="[codeType === '3' ? 'pop-busi' : '']">
    <div class="popover-tag" :class="[codeType === '3' ? 'popover-tag-busi' : '']" @click="pop($event)">
      <slot ref="slot" />
    </div>
    <div
      class="popover-wrap"
      :class="[codeType === '3' ? 'popover-wrap-busi' : '']"
      :style="{
        visibility: show && showTitle ? 'visible' : 'hidden'
      }"
      ref="pop"
    >
      <div class="popover-box" :class="[codeType === '3' ? 'popover-box-busi' : '']">
        <div class="popover-effe">
          <div v-if="codeType === '3'" class="popover-title">
            {{ contTitle }}
          </div>
          <div v-if="codeType === '2'" class="popover-title">
            {{ contTitle }}
          </div>
          <div v-if="codeType === '1'" class="popover-title">{{ purTitle.productName }} {{ purTitle.spec }}</div>
        </div>

        <div class="popover-arrow " :class="[codeType === '3' ? 'popover-arrow-busi' : '']" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    contTitle: {
      type: String,
      default: "标题"
    },
    purTitle: {
      type: Object,
      default: () => {}
    },
    codeType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: false,
      showTitle: false,
      arrowLeft: 0,
      x: 0,
      y: 0
    }
  },
  created() {
    document.body.addEventListener("touchstart", this.closeShow, true)
  },
  destroyed() {
    document.body.removeEventListener("touchstart", this.closeShow, true)
  },
  methods: {
    pop(e) {
      e.target.scrollWidth > e.target.offsetWidth ? (this.showTitle = true) : (this.showTitle = false)
      if (this.show) {
        this.show = false
        return
      }
      this.show = true
    },
    closeShow(e) {
      if (this.$slots && this.$slots.default) {
        if (e.target !== this.$slots.default[0].elm) {
          this.show = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pop {
  position: relative;
  .popover-wrap {
    position: relative;
    z-index: 9999;
    left: -38px;
    top: 2px;
    .popover-box {
      border-radius: 4px;
      background: #ffffff;
      width: 250px;
      position: absolute;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
      .popover-effe {
        font-size: 12px;
        margin: 3px 3px 0 6px;
        font-weight: 400;
        color: #343d54;
        .popover-title {
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 12px;
          margin-bottom: 4px;
          color: #343d54;
          line-height: 20px;
        }
        .popover-cont {
          p {
            margin-bottom: 4px;
            margin-top: 0;
            font-size: 12px;
            color: #343d54;
            height: 17px;
            line-height: 17px;
          }
        }
      }
      .popover-arrow {
        position: absolute;
        left: 125px;
        border: 7px solid transparent;
        border-top-width: 0;
        border-bottom-color: #ffffff;
        top: -5px;
      }
    }
  }
}
.pop-busi {
  display: block;
  width: calc(100% - 29px);
  .popover-tag-busi {
    display: flex;
    width: 100%;
  }
  .popover-wrap-busi {
    position: relative;
    z-index: 9999;
    left: -20px;
    top: 2px;
    width: 160px;
    .popover-box-busi {
      width: 100%;
      .popover-arrow-busi {
        left: 76px;
      }
    }
  }
}
</style>
